import AuthContainer from './AuthContainer';
export default AuthContainer;



// WEBPACK FOOTER //
// ./src/layout/App/components/AuthContainer/index.js